// app/shared/components/button/HTFButtonComponent.tsx
//
// Thin alias shim over fluxos-lib-ui's canonical FLButton (kit subpath).
// Verified prop-compatible superset (variants, isLoading, icon, iconAfter,
// asChild) — call sites keep importing HTFButton/ButtonProps unchanged.
// Canonical implementation now lives in fluxos-lib-ui; do not restyle here.
export type { FLButtonProps as ButtonProps } from "@ogattermayr/fluxos-lib-ui/kit";
export {
  flButtonVariants as buttonVariants,
  FLButton as HTFButton,
} from "@ogattermayr/fluxos-lib-ui/kit";
